export * from './IconDocDelete';
